export const bgImages = () => {
  // const context = require.context('assets/bgImages/', false, /bgImages\/.*\.(png|jpe?g|svg)$/)
  const context = require.context('assets/bgImages/', false, /bgImages\/.*$/)
  return context.keys().map((key) => context(key))
}
